<template>
  <div class="box">
    <div class="row">
      <div class="col-md-12 m-3">
        <h3>Receipts</h3>
      </div>
    </div>
    <hr/>
    <div class="row"  v-if="booking.payments.length > 0 || booking.old_payments.length > 0">
      <div class="col-md-12">
        <table class="table" cellspacing="0" cellpadding="0" >
          <thead>
            <tr>
              <th>Transaction ID</th>
              <th>Method</th>
              <th>Amount</th>
              <th>Time of transaction</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="payment of booking.payments" :key="payment.id">
              <td>{{ payment.transaction_id }}</td>
              <td>{{ payment.payment_method }}</td>
              <td>{{ payment.payment_amount | formatCurrency  }}</td>
              <td>{{ payment.created_at | formatDateTime }}</td>
            </tr>
            <tr v-for="payment of booking.old_payments" :key="payment.id">
              <td>{{ payment.transaction_id }}</td>
              <td>{{ payment.payment_method }}</td>
              <td>{{ payment.payment_amount | formatCurrency  }}</td>
              <td>{{ payment.created_at | formatDateTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'BookingReceipts',
  props : {
    booking: Object,
  }
}
</script>

